import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "canary_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const fetchDeck = async () => {
  const res = await axios.get(`${API}/deck`);
  return res.data;
};

export const login = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  setToken(res.data.token);
  return res.data.token;
};

export const saveDeck = async (deck) => {
  const res = await axios.put(
    `${API}/deck`,
    { deck },
    { headers: { Authorization: `Bearer ${getToken()}` } }
  );
  return res.data;
};

export const resetDeck = async () => {
  const res = await axios.post(
    `${API}/deck/reset`,
    {},
    { headers: { Authorization: `Bearer ${getToken()}` } }
  );
  return res.data;
};
